import { CollectionPopUp } from "./CollectionPopUp";

export default CollectionPopUp;
